import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList } from "@/mocks/anime";

export default function LatestAnime() {
  const latest = [...animeList]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, 10);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
            最新动漫更新
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            紧跟进度，不错过每一次更新
          </p>
        </div>
        <Link
          to="/anime"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4"
        data-product-shop
      >
        {latest.map((anime) => (
          <AnimeCard key={anime.id} anime={anime} />
        ))}
      </div>
    </section>
  );
}